module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABXUlEQVQ4ja3UPUscURTG8d8Oa2S3EAujEFOkSKI2FjZ2fgMbjVUs0gSCmEQRBCFFGtHKL2BpJ6IgNlarpYKkU5JAioTgNiGKJEUQTHHvggwzs77s0xzmmXP+c85w7i3VajVNtIz3OMQ8DoqSkyawLrxDG0awj6H7AN+igiW8QTs+FhWUCkau4Ds68AR1/MEZHt2lw0lh5DWc4gr/UC3qMA+YYC5CVooAaZVz/FH0YRfHqXdVrKe8M2xjJw84E+Nyyq/HD01k1LzGbDl2OYsxYT1Kwmp8wl6qaBhPM2A92MBCGYvCwqa1meGd4yjDh9/oTPBK+AePY3dTMeEypzBLHcIqfU3QjR/4eQtAWv0xnjQ7KTdVX4yfWwUcaDWw0WFLR77Cl1YAy3gmXCR/E1wIl8CDOwIHY+1Jg76Nl/gmHK2HMXEaL24AfB7jVgM4HY1x9F5L7E095+kXPmAV/gMXPj13a338lgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dianzan.png
// module id = Zrnc
// module chunks = 10